module.exports = __webpack_public_path__ + "static/img/animals.414c6869.jpg";